module.exports = __webpack_public_path__ + "img/Gran_Coupé.90708929.jpg";